<!-- eslint-disable indent -->
<template>
  <div class="main" v-if="configObj" :style="{ background: navBack ,color:pc_font_color}">
    <p>
      <span v-if="configObj.one_txt">{{ configObj.one_txt }}</span>
    </p>
    <p>
      <span v-if="configObj.two_left_txt">{{ configObj.two_left_txt }}:</span>
      <span v-if="configObj.two_right_txt" style="cursor:pointer" @click="twoRighClick">{{ configObj.two_right_txt
      }}</span>
    </p>
    <p>
      <span v-if="configObj.three_left_txt">{{ configObj.three_left_txt }}:</span>

      <span v-if="configObj.three_right_txt" style="cursor:pointer" @click="threeRighClick">{{ configObj.three_right_txt
      }}</span>
    </p>
    <p>
      <span v-if="configObj.attach_txt">{{ configObj.attach_txt }}</span>
    </p>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        configObj: {},
        navBack: "#000000",
        pc_font_color: "#FFFFFF",
      }
    },
    mounted() {
      this.getConfig()
    },
    methods: {
      twoRighClick() {
        window.open(this.configObj.two_right_link)
      },
      threeRighClick() {
        window.open(this.configObj.three_right_link)
      },
      getConfig() {
        this.$http.post('?s=/apiPc.Index/config')
          .then(response => {
            this.configObj = response.data.home_copyright;

            this.navBack = response.data.sysset.pc_theme_color ? response.data.sysset.pc_theme_color : "";
            this.pc_font_color = response.data.sysset.pc_font_color ? response.data.sysset.pc_font_color : "";
          })
          .catch(error => {});
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .main {
    padding: 50px 0;
  }

  .main p {
    font-size: 12px;
    text-align: center;
    line-height: 20px;
  }
</style>


// WEBPACK FOOTER //
// src/views/footer/index.vue